export default {
    showVariationsModal: {
        copy: 'Kopie',
        contentVariation: 'Content variatie',
        chosenContent: 'Gekozen content',
        chosenContentPlaceholder: 'Invullen aub',
        continue: 'Doorgaan',
        generateNewContent: 'Geneer nieuwe content',
        type: 'Type:',
        contentTitle: 'Titel:',
        descriptionLabel: 'Omschrijving:',
        keywordsLabel: 'Trefwoorden:',
        writingTone: 'Schrijftoon:',
        context: 'Context:',
        cancel: 'Annuleer',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
